import { atom } from 'jotai'

export type TCommissionSortKey = 'period' | 'earningsFormatted' | 'withheldFormatted' | 'paidAmountFormatted'

export type TCommissionResponse = {
    data: TCommissionResponseRow[]
}

export type TCommissionResponseRow = {
    downloadUrl: string
    earnings: number
    earningsFormatted: string
    paidAmount: number
    paidAmountFormatted: string
    period: string
    withheld: number
    withheldFormatted: string
}

export const commissionDataAtom = atom<TCommissionResponseRow[]>([])
export const commissionIsLoadingAtom = atom(false)
export const commissionErrorAtom = atom('')
export const commissionHasFetchedAtom = atom(false)
export const commissionLastBaidAtom = atom<string | null>(null)

